/* The gallery's first frame is plain HTML/CSS. This file adds navigation and image warming. */
(function () {
  if (window.FemureGallery) return;

  function init(root) {
    if (root.__femureGallery) return;
    var main = root.querySelector('.lp-hero__main');
    var thumbs = root.querySelector('.lp-hero__thumbs');
    if (!main || !thumbs) return;
    var track = main.querySelector('.swiper-wrapper');
    var originals = Array.from(track.children);
    var buttons = Array.from(thumbs.querySelectorAll('.swiper-slide'));
    var count = originals.length;
    if (!count) return;
    var media = window.matchMedia('(max-width: 991px)');
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var abort = new AbortController();
    var options = { signal: abort.signal };
    var active = 0, prefix = 0, stride = 0, lastWidth = 0, timer;
    var dragging = null, animation = 0, moving = false;

    originals.forEach(function (slide, i) {
      slide.dataset.galleryIndex = i;
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', (i + 1) + ' / ' + count);
      slide.querySelectorAll('img').forEach(function (image) { image.draggable = false; });
    });
    main.tabIndex = 0;
    thumbs.style.setProperty('--gallery-thumb-count', Math.min(7, count));

    function warm(index) {
      index = (index + count) % count;
      Array.from(track.children).forEach(function (slide) {
        if (Number(slide.dataset.galleryIndex) !== index) return;
        slide.querySelectorAll('[data-gallery-srcset]').forEach(function (image) {
          image.srcset = image.dataset.gallerySrcset;
          image.sizes = image.dataset.gallerySizes;
          image.removeAttribute('data-gallery-srcset');
          image.removeAttribute('data-gallery-sizes');
        });
      });
    }

    function mark(physical) {
      var slide = track.children[physical];
      if (!slide) return;
      active = Number(slide.dataset.galleryIndex);
      Array.from(track.children).forEach(function (item, i) {
        item.classList.toggle('swiper-slide-active', i === physical);
      });
      buttons.forEach(function (button, i) {
        button.classList.toggle('swiper-slide-thumb-active', i === active);
        button.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
      warm(active);
      warm(active + 1);
    }

    function clone(index) {
      var copy = originals[index].cloneNode(true);
      copy.dataset.galleryClone = '';
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('id');
      copy.removeAttribute('data-shopify-editor-block');
      copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      copy.querySelectorAll('img').forEach(function (image) {
        image.loading = 'lazy';
        image.fetchPriority = 'low';
      });
      return copy;
    }

    function refresh() {
      cancelAnimation();
      clearTimeout(timer);
      track.querySelectorAll('[data-gallery-clone]').forEach(function (slide) { slide.remove(); });
      prefix = media.matches && count > 1 ? 1 : 0;
      if (prefix) {
        track.prepend(clone(count - 1));
        track.append(clone(0), clone(1));
      }
      stride = originals[0].getBoundingClientRect().width + 12;
      lastWidth = main.clientWidth;
      main.scrollLeft = (active + prefix) * stride;
      mark(active + prefix);
      main.classList.add('swiper-initialized');
    }

    function dimensionsChanged() {
      return Math.abs(main.clientWidth - lastWidth) > 0.5 ||
        Boolean(prefix) !== (media.matches && count > 1);
    }

    function settle() {
      if (dimensionsChanged()) { refresh(); return; }
      if (dragging || moving || !stride) return;
      var physical = Math.round(main.scrollLeft / stride);
      var slide = track.children[physical];
      if (!slide) return;
      if (slide.hasAttribute('data-gallery-clone')) {
        physical = Number(slide.dataset.galleryIndex) + prefix;
        main.scrollLeft = physical * stride;
      }
      mark(physical);
    }

    function cancelAnimation() {
      cancelAnimationFrame(animation);
      moving = false;
      if (!dragging) main.style.scrollSnapType = '';
    }

    function go(index) {
      var physical = index + prefix;
      if (!prefix) physical = Math.max(0, Math.min(count - 1, physical));
      warm(index);
      warm(index + 1);
      cancelAnimation();
      var target = physical * stride;
      if (motion.matches) {
        main.scrollLeft = target;
        settle();
        return;
      }
      var start = main.scrollLeft, began = performance.now();
      moving = true;
      main.style.scrollSnapType = 'none';
      function frame(now) {
        var progress = Math.min(1, (now - began) / 300);
        main.scrollLeft = start + (target - start) * (1 - Math.pow(1 - progress, 3));
        if (progress < 1) animation = requestAnimationFrame(frame);
        else {
          moving = false;
          main.style.scrollSnapType = '';
          main.scrollLeft = target;
          settle();
        }
      }
      animation = requestAnimationFrame(frame);
    }

    main.addEventListener('scroll', function () {
      if (dimensionsChanged()) { refresh(); return; }
      if (!stride) return;
      mark(Math.round(main.scrollLeft / stride));
      clearTimeout(timer);
      timer = window.setTimeout(settle, 160);
    }, { passive: true, signal: abort.signal });
    main.addEventListener('scrollend', settle, options);
    main.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      go(active + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    main.addEventListener('pointerdown', function (event) {
      cancelAnimation();
      warm(active - 1);
      warm(active + 1);
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = { x: event.clientX, left: main.scrollLeft };
      main.style.scrollSnapType = 'none';
      main.setPointerCapture(event.pointerId);
      event.preventDefault();
    }, options);
    main.addEventListener('pointermove', function (event) {
      if (dragging) main.scrollLeft = dragging.left + dragging.x - event.clientX;
    }, options);
    function stopDragging() {
      if (!dragging) return;
      dragging = null;
      main.style.scrollSnapType = '';
      go(Math.round(main.scrollLeft / stride) - prefix);
    }
    main.addEventListener('pointerup', stopDragging, options);
    main.addEventListener('pointercancel', stopDragging, options);
    buttons.forEach(function (button, i) {
      button.tabIndex = 0;
      button.setAttribute('role', 'button');
      button.setAttribute('aria-label', (i + 1) + ' / ' + count);
      button.addEventListener('click', function () { go(i); }, options);
      button.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          go(i);
        }
      }, options);
    });
    media.addEventListener('change', refresh, options);
    refresh();
    var resize = new ResizeObserver(function () {
      if (Math.abs(main.clientWidth - lastWidth) > 0.5) refresh();
    });
    resize.observe(main);
    root.__femureGallery = {
      destroy: function () {
        abort.abort(); resize.disconnect(); clearTimeout(timer); cancelAnimation();
        track.querySelectorAll('[data-gallery-clone]').forEach(function (slide) { slide.remove(); });
        delete root.__femureGallery;
      }
    };
  }

  window.FemureGallery = { init: init };
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.lp-hero');
    if (root && root.__femureGallery) root.__femureGallery.destroy();
  });
})();
